import { useCallback } from "react"

import { CatalogItemsFiltersFormError, CatalogItemsFiltersFormSkeleton } from "@l2r-front/l2r-common"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { EquipmentFiltersFormPost } from "../../forms/EquipmentFiltersForm"
import { useEquipmentProject } from "../../hooks/queries/equipment/useEquipmentProject"

import * as Styled from "./EquipmentFilters.styled"

export function EquipmentFilters(props) {

    const {
        className,
        close,
        displayFilters,
    } = props

    const { data, isError, isLoading } = useEquipmentProject()

    const EquipmentFiltersContent = useCallback(() => {
        if (isError) {
            return <CatalogItemsFiltersFormError />
        } else if (isLoading) {
            return <CatalogItemsFiltersFormSkeleton />
        }
        return <EquipmentFiltersFormPost close={close} projectTags={data?.tags} />
    }, [close, data, isError, isLoading])


    return <div className={className}>
        <Styled.Collapse in={displayFilters}>
            <EquipmentFiltersContent close={close} />
        </Styled.Collapse>
    </div>
}

EquipmentFilters.propTypes = {
    className: PropTypes.string,
    close: PropTypes.func.isRequired,
    displayFilters: PropTypes.bool.isRequired,
}